/**
 * Fantasy Console 0 - Toast Container Component
 */

import { useToast } from '../../context/ToastContext'
import { Toast } from './Toast'
import styles from './ToastContainer.module.css'

export function ToastContainer() {
  const { toasts, dismissToast } = useToast()

  if (toasts.length === 0) return null

  return (
    <div className={styles.container} aria-live='polite' aria-atomic='false'>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onDismiss={() => dismissToast(toast.id)}
        />
      ))}
    </div>
  )
}
